module.exports = __webpack_public_path__ + "2021120:beba53acebe35c990492/img/group_8.a1f4738.png";